import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { actualityEffectiveFilterConfig } from '../feed/store/actuality.state';
import { simulationEffectiveFilterConfig } from '../simulation/store/simulation.state';
import { filterPresetTypeSelected } from './store/filterPreset.state';

function useFilterPresetConfig() {
  const { t } = useTranslation('app');
  const filterPresetType = useRecoilValue(filterPresetTypeSelected);
  const actualityEffective = useRecoilValue(actualityEffectiveFilterConfig);
  const simulationEffective = useRecoilValue(simulationEffectiveFilterConfig);
  switch (filterPresetType) {
    case 'simulationHq':
      return simulationEffective;
    case 'actualityAssignment':
    case 'actualityHq':
      return actualityEffective;
  }
}

export default useFilterPresetConfig;
